module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-1-90514fd468a6d8ff7697e0bdb3ed70b5.webp";